module.exports = __webpack_public_path__ + "static/img/yytx24.ad7b98e.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/details/QRcode/yytx24.png
// module id = 803
// module chunks = 0